/**
 * PaymentMethodType enum — synced with backend C# enum.
 * Backend is the single source of truth. Numeric values must match exactly for API serialization.
 */
export enum PaymentMethodType {
  None = 0,
  Card = 1,
  Cash = 2,
  Upi = 3,
  Qr = 4,
  Other = 5
}
